import React from "react";
import Slider from "react-slick";
import { Animated } from "react-animated-css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSiteSettings, resolveMediaUrl } from '../../siteSettings';
import "../hero/style.css";

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

const HeroMain = () => {
  const settings = useSiteSettings();
  const parseMedia = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value !== 'string' || !value.trim()) return [];
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
    } catch (error) {
      return [];
    }
  };
  const mediaValue = parseMedia(settings.carouselMedia || settings.carousel_media);
  const imageValue = parseMedia(settings.carouselImages || settings.carousel_images);
  const configuredMedia = mediaValue.length ? mediaValue : imageValue;
  const slides = configuredMedia
    .map((item) => {
      if (typeof item === 'string') return { type: 'image', src: item };
      if (!item || !(item.src || item.url || item.path || item.file)) return null;
      const type = item.type === 'video' || item.mediaType === 'video' ? 'video' : 'image';
      return { type, src: item.src || item.url || item.path || item.file };
    })
    .filter(Boolean);
  const dateText = [formatDate(settings.weddingDate), settings.weddingTime].filter(Boolean).join(' — ');

  if (!slides.length) return null;

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: false,
    pauseOnFocus: false,
    fade: true,
  };

  return (
    <Slider {...sliderSettings}>
      {slides.map((slide, index) => (
        <div
          id={index === 0 ? 'home' : undefined}
          className="items1"
          key={`${slide.type}-${slide.src}`}
        >
          {slide.type === 'image' && <img className="hero-slide-image" src={resolveMediaUrl(slide.src)} alt="" />}
          {slide.type === 'video' && <video className="hero-slide-video" autoPlay loop muted playsInline><source src={resolveMediaUrl(slide.src)} type="video/mp4" /></video>}
          <div className="container">
            <div className="slide-content">
              <div className="slide-subtitle"><h4>NOUS ALLONS NOUS MARIER</h4></div>
              <div className="slide-title"><h2>Réservez la date</h2></div>
              <div className="slide-text"><p>{dateText}</p></div>
              <Animated><div className="animated-circle" /></Animated>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default HeroMain;
